const ITEMS = [
  "The Mind Is The Last Frontier",
  "Decoding Human Nature",
  "Psychology",
  "Behavior",
  "Consciousness",
  "Truth",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee"
      className="relative border-y border-white/8 bg-[#080808] py-6 md:py-8 overflow-hidden"
    >
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-3xl md:text-5xl text-white/85 px-8">
              {t}
            </span>
            <span
              className="h-2 w-2 rounded-full"
              style={{ background: "var(--noir-crimson)" }}
            />
          </span>
        ))}
      </div>
    </section>
  );
}
